import { useEffect } from 'react'
import { Modal } from 'react-bootstrap'

// Full-screen viewer for the food photo and the original card photos, with arrows between them
const RecipePhotoViewer = ({ photos = [], index = null, onChange, onHide }) => {
  const show = index !== null && !!photos[index]
  const count = photos.length
  const photo = show ? photos[index] : null

  const go = (step) => onChange((index + step + count) % count)

  useEffect(() => {
    if (!show || count < 2) return undefined
    const onKey = (e) => {
      if (e.key === 'ArrowRight') go(1)
      if (e.key === 'ArrowLeft') go(-1)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [show, index, count])

  return (
    <Modal dialogClassName="photoViewerDialog" fullscreen show={show} onHide={onHide}>
      {photo && (
        <div className="photoViewer" onClick={onHide}>
          <div className="photoViewerTop" onClick={(e) => e.stopPropagation()}>
            <span className="photoViewerCaption">
              {photo.label}
              {count > 1 ? ` · ${index + 1} of ${count}` : ''}
            </span>
            <button type="button" className="photoViewerClose" onClick={onHide} aria-label="Close">
              ×
            </button>
          </div>
          <img
            className="photoViewerImg"
            src={photo.image}
            alt={photo.label}
            onClick={(e) => e.stopPropagation()}
          />
          {count > 1 && (
            <>
              <button
                type="button"
                className="photoViewerArrow photoViewerPrev"
                aria-label="Previous photo"
                onClick={(e) => {
                  e.stopPropagation()
                  go(-1)
                }}
              >
                ‹
              </button>
              <button
                type="button"
                className="photoViewerArrow photoViewerNext"
                aria-label="Next photo"
                onClick={(e) => {
                  e.stopPropagation()
                  go(1)
                }}
              >
                ›
              </button>
            </>
          )}
        </div>
      )}
    </Modal>
  )
}

export default RecipePhotoViewer
